import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import routes from './routes'
import { authGuard } from '@/auth'
import { adminGuard } from '@/auth'
import { globalGuard } from '@/auth'
import { addBreadcrumb, addSentryContext } from '@/config/sentry.config'

Vue.use(Router)
Vue.use(Meta)

const router = make(routes)

// Add Sentry navigation tracking
router.beforeEach((to, from, next) => {
    // Add breadcrumb for navigation
    addBreadcrumb(
        `Navigation from ${from.name || from.path} to ${to.name || to.path}`,
        'navigation',
        'info'
    )

    // Add route context to Sentry
    addSentryContext('route', {
        from: from.path,
        to: to.path,
        fromName: from.name,
        toName: to.name,
    })

    next()
})

// Guard
router.beforeEach(globalGuard)

// Track navigation errors
router.onError(error => {
    addBreadcrumb(`Router error: ${error.message}`, 'error', 'error')

    addSentryContext('routerError', {
        error: error.message,
        stack: error.stack,
    })
})

export default router

/**
 * Create a new router instance.
 *
 * @param  {Array} routes
 * @return {Router}
 */
function make(routes) {
    const router = new Router({
        routes,
        scrollBehavior,
        mode: 'history',
    })
    return router
}

/* eslint-disable no-unused-vars */
function globalUserGuard(routes) {
    return beforeEnter(routes, (to, from, next) => {
        globalGuard(to, from, next)
    })
}

/* eslint-disable no-unused-vars */
function adminUserGuard(routes) {
    return beforeEnter(routes, (to, from, next) => {
        adminGuard(to, from, next)
    })
}

/**
 * Redirect home if authenticated.
 *
 * @param  {Array} routes
 * @return {Array}
 */
function userGuard(routes) {
    return beforeEnter(routes, (to, from, next) => {
        authGuard(to, from, next)
    })
}
/* eslint-enable no-unused-vars */
/**
 * Apply beforeEnter guard to the routes.
 *
 * @param  {Array} routes
 * @param  {Function} beforeEnter
 * @return {Array}
 */
function beforeEnter(routes, beforeEnter) {
    return routes.map(route => {
        return { ...route, beforeEnter }
    })
}
/**
 * @param  {Route} to
 * @param  {Route} from
 * @param  {Object|undefined} savedPosition
 * @return {Object}
 */
function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    }

    const position = {}

    if (to.hash) {
        position.selector = to.hash
    }

    if (to.matched.some(m => m.meta.scrollToTop)) {
        position.x = 0
        position.y = 0
    }

    return position
}

// eslint-disable-next-line no-unused-vars
function checkPermissions(req) {
    return true
}
